//#region Lang And Currency
function changeSiteLanguage(langID, langCode) {

    var url = "/";
    var Catalogs = $("#PgCatalogs").val().split("/");
    var ctlgs = "";

    for (var i = 0; i < Catalogs.length; i++) {
        if (Catalogs[i].length > 0) {
            ctlgs += "&Cats=" + Catalogs[i];
        }
    }

    $.ajax({
        type: 'get',
        url: '/Home/ChangePageLang',
        data: 'PID=' + $("#PID").val() + "&PgType=" + $("#PgType").val() + "&AName=" + $("#AName").val() + "&CName=" + $("#CName").val() + "&langID=" + langID + ctlgs + "&langCode=" + langCode,
        success: function (dt) {
            window.parent.location.href = dt;
        }
    });

}

function ShowLangAreaForChange() {
    var userLang = navigator.language || navigator.userLanguage;

    if (userLang != null && userLang != undefined && userLang.length > 2) {
        userLang = userLang.substr(0, 2).toLowerCase();
    }

    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/Home/ShowLangSwitch",
        success: function (data) {

            if ($(".LangSelectionArea").length <= 0) {

                if (document.URL.indexOf("localhost") >= 0) {

                    $(".FixedHeader > .container:first").prepend(data);
                }
            }
            else if ($(".LangSelectionArea").hasClass("gizle")) {

                if (document.URL.indexOf("localhost") >= 0) {

                    $(".LangSelectionArea").show();
                }
            }
            else {
                $(".LangSelectionArea").hide();
            }
        }
    });
}

function ShowCurrencyForChange() {
    $.ajax({
        type: "GET",
        url: getRequestRoute() + "/p/Home/ShowCurrencySwitch",
        success: function (data) {

            if ($(".CurrrencySelectionArea").length <= 0) {

                if ($(".AllowCurrencyChange").length > 0) {

                    $(".FixedHeader > .container:first").prepend(data);
                }

            } else if ($(".CurrrencySelectionArea").hasClass("gizle")) {

                if ($(".AllowCurrencyChange").length > 0) {

                    $(".CurrencySelectionArea").show();
                }


            } else {

                $(".CurrrencySelectionArea").hide();
            }

        }
    });

}

function CountryControlForModal() {
    if ($("#AnotherCountry").length > 0 && $("#AnotherCountry").val() != "False") {

        $("#AnotherCountryModal").modal({
            keyboard: false,
            handleUpdate: false,
            backdrop: 'static'
        });
    }

    $(document).on("click", "#AnotherCountryModal .confirmButton", function () {
        $("#AnotherCountryModal").modal("hide");
    });

    $('#AnotherCountryModal').on('hidden.bs.modal', function (e) {
        $("#AnotherCountryModal").remove();
    });
}
//#endregion Lang And Currency

function TopLink() {
    $('.top_link').hide();
    $('.top_link').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    });

    var showTopLink = 100;
    $(window).scroll(function () {
        if ($('.top_link').length > 0) {

            if ($(window).scrollTop() > showTopLink) {
                $('.top_link').fadeIn('slow');
            } else {
                $('.top_link').fadeOut('slow');
            }
        }
    });

    $(document).on("click", ".BrandContent .brand-filter > a", function () {
        var target = $(this).attr("data-href");

        var targetdiv = document.getElementById(target);

        if (targetdiv != null && targetdiv != undefined) {
            $('html, body').animate({ scrollTop: (targetdiv.offsetTop) }, 'slow');
        }
    });
}

function ContentPageSetteing() {
    if ($("body").hasClass("contentpg") && $("#contentCollapse").length > 0) {
        var urlParams = new URLSearchParams(window.location.search);
        var myParam = urlParams.get('param');

        if (myParam == "iade") {
            $("#contentCollapse .card.iade .card-header button").trigger("click");

            var iadeDivTop = window.scrollY + document.querySelector('.card.iade').getBoundingClientRect().top;

            if (iadeDivTop != null && iadeDivTop != undefined && iadeDivTop != "") {
                GenerateLocalLoading($("body"), "show");

                setTimeout(function () {
                    $('html, body').animate({
                        scrollTop: (iadeDivTop - 200)
                    }, 0);

                    GenerateLocalLoading($("body"), "hide");
                }, 1000);
            }
        }
    }
}

function GetInsiderObjectForHome() {
    var cName = $("#CName").val();

    if (cName == "Home") {
        $.ajax({
            type: 'get',
            url: getRequestRoute() + "/p/Home/GetInsiderObjectForHome",
            data: "Cname=" + cName,
            dataType: 'json',
            async: true,
            success: function (dt) {
                window.insider_object = jQuery.parseJSON(dt);
            }
        });
    }
}

function CalculateTopForWhatsapInfoSection() {
    var footerHeigh = parseInt($("header").css("height").split("px")[0]);
    var banner1Height = parseInt($("#Anasayfa1").css("height").split("px")[0]);
    document.getElementById("whatsapInfo").style.display = "inline";

    document.getElementById("whatsapInfo").style.top = (((footerHeigh + banner1Height) / 100) * 90.3) + "px";
}

function LoginRegisterModalEvents() {
    $('#LoginRegisterModal').on('hide.bs.modal', function () {
        $("#LoginRegisterModal .LoginForm").trigger("reset");
        $("#LoginRegisterModal .RegisterForm").trigger("reset");
        $("#LoginRegisterModal .ForgettenForm").trigger("reset");
    });

    $(document).on("click", ".OrderContentDetails .RegisterForCoupon .LoginRegister", function (e) {
        var event = $(this).attr("data-event");

        if (event == "login") {
            $("#LoginRegisterModal").modal('show');
            $("#LoginRegisterModal .LoginPanel").show();
            $("#LoginRegisterModal .RegisterPanel").hide();
        }
        else if (event == "register") {
            $("#LoginRegisterModal").modal('show');
            $("#LoginRegisterModal .LoginPanel").hide();
            $("#LoginRegisterModal .RegisterPanel").show();
        }

        return false;
    });

    $(document).on("click", "#LoginRegisterModal .NowRegister, #LoginRegisterModal .OpenLoginPanel, #LoginRegisterModal .ForgetPass, #LoginRegisterModal .CancelForgettenPass", function (e) {
        var event = $(this).attr("data-event");
        if ($(this).hasClass("NowRegister")) {
            $("#LoginRegisterModal .RegisterPanel").show();
            $("#LoginRegisterModal .LoginPanel").hide();
            $("#LoginRegisterModal .ForgettenPassPanel").hide();
            $("#LoginRegisterModal .modal-header .login-tittle").css("display", "none")
            $("#LoginRegisterModal .modal-header .register-tittle").css("display", "block")

        }
        else if ($(this).hasClass("OpenLoginPanel") || $(this).hasClass("CancelForgettenPass")) {
            $("#LoginRegisterModal .LoginPanel").show();
            $("#LoginRegisterModal .RegisterPanel").hide();
            $("#LoginRegisterModal .ForgettenPassPanel").hide();
            $("#LoginRegisterModal .modal-header .register-tittle").css("display", "none")
            $("#LoginRegisterModal .modal-header .login-tittle").css("display", "block")
            $("#LoginRegisterModal .modal-title").css("display", "block")
            $("#LoginRegisterModal .modal-title-forgotpass").css("display", "none")
        }
        else {
            $("#LoginRegisterModal .LoginPanel").hide();
            $("#LoginRegisterModal .RegisterPanel").hide();
            $("#LoginRegisterModal .ForgettenPassPanel").show();
            $("#LoginRegisterModal .modal-title").css("display", "none")
            $("#LoginRegisterModal .modal-header .modal-title-forgotpass").css("display", "block")
        }

        return false;
    });

    $(document).on("click", "#LoginRegisterModal .ContinueWithoutMember", function (e) {
        SetMemberless();
    });

    $(document).on("click", "#LoginRegisterModal .close", function (e) {
        $("#LoginRegisterModal").modal('hide');
    });

    $(document).on("submit", "#LoginRegisterModal form.LoginForm, #LoginRegisterModal form.RegisterForm", function () { /*#LoginRegisterModal form.ForgettenForm*/
        LoginRegisterFormSubmit($(this));
        return false;
    });

    $(document).on("click", "#userlogin, #UserMenus #UserAndBasket #AccountLink .login", function () {
        $("#LoginRegisterModal").modal('show');
        $("#LoginRegisterModal .ForgettenPassPanel").hide();
        $("#LoginRegisterModal .RegisterPanel").hide();
        $("#LoginRegisterModal .LoginPanel").show();
        $("#LoginRegisterModal .modal-header .register-tittle").css("display", "none");
        $("#LoginRegisterModal .modal-header .login-tittle").css("display", "block");
    });

    $(document).on("click", "#UserMenus #UserAndBasket #AccountLink .register", function () {
        $("#LoginRegisterModal").modal('show');
        $("#LoginRegisterModal .LoginPanel").hide();
        $("#LoginRegisterModal .ForgettenPassPanel").hide();
        $("#LoginRegisterModal .RegisterPanel").show();
        $("#LoginRegisterModal .modal-header .login-tittle").css("display", "none");
        $("#LoginRegisterModal .modal-header .register-tittle").css("display", "block");
    });

    $(document).on("click", ".Mobilmenu .MobileMenuFooter .login", function () {

        $("body > .Mobilmenu > ul").removeClass("open");
        $("body > .Mobilmenu > ul > li").removeClass("open");
        $("body > .Mobilmenu > ul > li > ul").removeClass("open");

        toggleMenusOperation("all");
        $("#LoginRegisterModal").modal('show');
        $("#LoginRegisterModal .ForgettenPassPanel").hide();
        $("#LoginRegisterModal .RegisterPanel").hide();
        $("#LoginRegisterModal .LoginPanel").show();
        $("#LoginRegisterModal .modal-header .register-tittle").css("display", "none")
        $("#LoginRegisterModal .modal-header .login-tittle").css("display", "block")
    });
    $(document).on("click", ".Mobilmenu .MobileMenuFooter .register", function () {

        $("body > .Mobilmenu > ul").removeClass("open");
        $("body > .Mobilmenu > ul > li").removeClass("open");
        $("body > .Mobilmenu > ul > li > ul").removeClass("open");

        toggleMenusOperation("all");
        $("#LoginRegisterModal").modal('show');
        $("#LoginRegisterModal .LoginPanel").hide();
        $("#LoginRegisterModal .ForgettenPassPanel").hide();
        $("#LoginRegisterModal .RegisterPanel").show();
        $("#LoginRegisterModal .modal-header .login-tittle").css("display", "none")
        $("#LoginRegisterModal .modal-header .register-tittle").css("display", "block")
    });

    $(document).on("click", ".swal2-confirm .loginbtn", function () {
        $(".swal2-container").hide();
        $("#LoginRegisterModal").modal('show');
        $("#LoginRegisterModal .ForgettenPassPanel").hide();
        $("#LoginRegisterModal .RegisterPanel").hide();
        $("#LoginRegisterModal .LoginPanel").show();
        $("#LoginRegisterModal .modal-header .register-tittle").css("display", "none")
        $("#LoginRegisterModal .modal-header .login-tittle").css("display", "block")
    });
}

function footerToggleClass() {
    if (isMobileResolution) {
        $(".FooterNav .footerMenu").live("click", function () {
            $(".FooterNav .footerMenu").not($(this)).removeClass("toggle-minus");
            $(this).toggleClass("toggle-minus");
        });
    }
}

function BrandCalculateScroll() {
    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('#') + 1); // QueryString okunur
    var targetdiv = document.getElementById(NativeQueryFilter);

    if (targetdiv != null && targetdiv != undefined) {
        $('html, body').animate({ scrollTop: (targetdiv.offsetTop) }, 'slow');
    }
}

$(document).ready(function () {

    if (isMobileResolution()) {
        SlickSlider("banner3lu");
    }

    SlickSlider("banner");
    //SlickSlider("lastaddedprd");

    $(document).on("click", ".Mainmenu .Brands > a", function () {
        var target = $(this).attr("href").split('#');
        var targetdiv = document.getElementById(target[1]);

        if (targetdiv != null && targetdiv != undefined) {
            $('html, body').animate({ scrollTop: (targetdiv.offsetTop) }, 'slow');
        }
    });

    BrandCalculateScroll();
    TopLink();
    CountryControlForModal();
    ContentPageSetteing();
    LoginRegisterModalEvents();

    //GetInsiderObjectForHome();

    footerToggleClass();
    $("body .backdrop").on("click", function (e) {
        toggleMenusOperation("all");
    });

    $(window).resize(function () {
        setContentHeight();
    });

    $(document).on("submit", "footer .NewsletterFormArea form", function () {
        form = $(this);
        GenerateLocalLoading($(" > div", form), "show");

        UserForms(form, function (dt) {
            if (dt.Sonuc == true) {
                GenerateLocalLoading(form, "hide");
                SwalGenerate("success", dt.IslemSonucAciklama, getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
            }
            else {
                var errorMsg = dt.IslemSonucAciklama;

                if (errorMsg == "" || errorMsg == null) {
                    errorMsg = dt;
                }

                SwalGenerate("error", errorMsg, getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
                GenerateLocalLoading($(" > div", form), "hide");
            }
        });

        return false;
    });

    $(document).on("click", ".errorContainer .SearchArea .input-group-append", function () {
        $(".SearchArea form").trigger("submit");
    });

    if (isMobileResolution()) {
        $(document).on("click", "footer .FooterNav .footerMenu.mobile-accordion", function () {
            $("footer .FooterNav .footerMenu.mobile-accordion ul").not($(this).find("ul")).slideUp();

            $(this).find("ul").slideToggle();
        });
    }

    $("#brand-Bottom a").on("click", function (e) {

        var href = $(this).attr('data-href');

        // alert("href: " + href);

        if (href == 'alpthabet-DİĞER') {
            $("#alpthabet-DİĞER").show();
        }
        else {
            $("#alpthabet-DİĞER").hide();
        }
    });

    if (window.location.href.indexOf("#alpthabet") > -1) {
        $("#alpthabet-DİĞER").hide();
    }
    else {
        $("#alpthabet-DİĞER").show();
    }
});

//$("#Anasayfa1 .SBannerImg").load(function () {
//    CalculateHeightForLeftInfoBar(false);
//});

//function CalculateHeightForLeftInfoBar(activeNewsArea) {
//    if (!isMobileResolution() && $("body").hasClass("home")) {
//        var banner1Height = $("#Anasayfa1").height();
//        var headerHeight = $("header").height();

//        document.getElementById("LeftInfoBar").style.height = (banner1Height + headerHeight) + "px";
//        document.getElementById("LeftInfoBar").style.visibility = "visible";

//        if (activeNewsArea) {
//            document.getElementById("LeftInfoBar").style.top = $("header .News").height() + "px";
//        }

//        //CalculateTopForWhatsapInfoSection();
//    }
//}